import React, { useRef } from 'react';
import { DownloadOutlined, ShareAltOutlined } from '@ant-design/icons';
import { GlassModal } from '../../glass';
import panther from '../../images/panther.png';
import './achievements.css';
import { downloadAchievement, shareAchievement } from './achievementShare';

// The card that gets saved / shared as an image
function Certificate({ title, description }) {
  return (
    <div className="ach-cert">
      <div className="ach-cert__circle" />

      <div className="ach-cert__brand">LINCFOLIO</div>

      <div className="ach-cert__body">
        <div className="ach-cert__kicker">ACHIEVEMENT UNLOCKED</div>
        <div className="ach-cert__title">{title}</div>
        <div className="ach-cert__desc">{description}</div>
      </div>

      <div className="ach-cert__bottom">
        <img className="ach-cert__mascot" src={panther} alt="" />
        <span className="ach-cert__site">lincfolio.com</span>
      </div>
    </div>
  );
}

export default function AchievementModal({ achievement, onClose }) {
  const certRef = useRef(null);
  if (!achievement) return null;

  return (
    <GlassModal open onClose={onClose} width={380}>
      <div className="ach-modal">
        <div ref={certRef}>
          <Certificate
            title={achievement.title}
            description={achievement.description}
          />
        </div>

        <button type="button" className="ach-btn ach-btn--gold" onClick={() => downloadAchievement(certRef.current, achievement.title)}>
          <DownloadOutlined /> Download Image
        </button>
        <button type="button" className="ach-btn ach-btn--ghost" onClick={() => shareAchievement(certRef.current, achievement.title)}>
          <ShareAltOutlined /> Share Achievement
        </button>
        <button type="button" className="ach-close" onClick={onClose}>Close</button>
      </div>
    </GlassModal>
  );
}